<app-dialog
  [title]="'Quick Create Mapping'"
  [actions]="[{ text: 'Cancel', buttonStyle: 'underline' },{ text: 'Create',spin: this.spin,isDisabled:this.form.invalid }]"
  (action)="action($event)"
  (close)="close()"
>
<div class="content pt-4">
    <div  [formGroup]="form">
        <div class="input-container mb-4">
            <div class="input-container_label d-flex">Vendor<span class="ms-auto">Creating {{totalCount | number}} Products</span></div>
            <input
            type="text"
            class="input-container_input"
            formControlName="vendor"
            [matAutocomplete]="auto"
            placeholder="Search"
          />
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith">
            <mat-option
              *ngFor="let option of filteredOptions$ | async"
              [value]="option"
              class="mat-option-override account-option"
            >
              {{ option.name }}
            </mat-option>
          </mat-autocomplete>
        </div>
        <p class="mb-3 font-bold">Select what you want to use for the “product id” and "vendor item"</p>
        <div class="custom-mat-radio">
            <mat-radio-group aria-label="Select an option" class="d-flex flex-column gap-2 mb-3 font_size_14" formControlName="radioOption">
              <mat-radio-button value="Sku" color="primary" >
                SKU
              </mat-radio-button>
            
              <mat-radio-button value="Asin" color="primary" >
                ASIN
              </mat-radio-button>
    
              <mat-radio-button value="Upc" color="primary" >
                UPC
              </mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
</div>
</app-dialog>
